<template>
    <b-card>
        <b-button variant="primary" @click="showAddOrEditMetaGroupModal">اضافه کردن گروه</b-button>
        <b-table
        responsive
                style="width: 100%"
                striped
                hover
                show-empty
                empty-text="آیتمی جهت نمایش وجود ندارد"
                :fields="fields"
                :items="metadataGroupList">
            <template v-slot:cell(edit)="row">
                <b-link  @click="editMetaGroup(row.item)" href="#">ویرایش</b-link>
            </template>
            <template v-slot:cell(details)="row">
                <b-link   :href="'#/metadata/' + row.item.id">جزییات</b-link>
            </template>
        </b-table>
        <b-modal ref="addmetagroup-modal" :title="metagroupModalTitle" style="justify-content: space-around"
                 hide-footer>
            <b-form>
                <b-row>
                    <b-col>
                    <label style="margin-left: auto">نام گروه</label>
                    <b-input id="input_metagroup_name" placeholder="نام گروه متا دیتا" v-model="metaGroupName"/>
                        </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <b-button style="width: 100%" variant="primary" @click="sendAddOrEditMetaGroupRequest">ذخیره
                        </b-button>
                    </b-col>
                    <b-col>
                        <b-button style="width: 100%" variant="danger" @click="hideAddOrEditMetaGroupModal">بازگشت
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </b-card>
</template>
<script>
    import httpHelper from "../../helpers/httpHelper";
    import persianDate from "../../helpers/persianDate";

    export default {
        name: "metadataGroups",
        data: function () {
            return {
                metaGroupName: null,
                metagroupModalTitle: 'اضافه کردن گروه متادیتا',
                metagroupName: null,
                metaGroupId: null,
                isInEditMode: false,
                metadataGroupList: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ردیف'
                    },
                    {
                        key: 'name',
                        label: 'نام گروه'
                    },
                    {
                        key: 'created_at',
                        label: 'تاریخ ایجاد'
                    },
                    {
                        key: 'updated_at',
                        label: 'تاریخ بروزرسانی'
                    },
                    {
                        key: 'edit',
                        label: 'ویرایش'
                    },
                    {
                        key: 'details',
                        label: 'جزییات'
                    }
                ]
            }
        },
        methods: {
            getMetadataGroups: function () {
                httpHelper.getData("metadata/groups").then(response => {
                    this.metadataGroupList = response.result
                    this.metadataGroupList.map((item) => {
                        if (item["created_at"]!==null)
                            item["created_at"] = persianDate.getDate(item["created_at"])
                        if (item["updated_at"]!==null)
                            item["updated_at"] = persianDate.getDate(item["updated_at"])
                    })
                }).finally(() => {

                })
            },
            showAddOrEditMetaGroupModal: function () {
                this.$refs["addmetagroup-modal"].show();
            },
            hideAddOrEditMetaGroupModal: function () {
                this.$refs["addmetagroup-modal"].hide();
            },
            sendAddOrEditMetaGroupRequest: function () {
                httpHelper.setAuth()
                let metaGroupData = {
                    name: this.metaGroupName
                }

                if (this.isInEditMode)
                    metaGroupData.id = this.metaGroupId

                httpHelper.postData("metadata/groups", metaGroupData).then(response => {
                    if (response.success === true) {
                        httpHelper.getData("metadata/groups")
                            .then(res => {
                                this.metadataGroupList = res.result;
                                console.log(res)
                            })
                            .finally(() => {

                            });
                    }
                })
                this.hideAddOrEditMetaGroupModal()

            },
            editMetaGroup: function (metaGroup) {
                httpHelper.setAuth()
                httpHelper.getData("metadata/groups?id=" + metaGroup.id).then(response => {
                    if (response.success = true) {
                        let metaGroup = response.result[0];
                        this.metaGroupName = metaGroup.name
                        this.metaGroupId = metaGroup.id
                        this.isInEditMode = true
                        this.metagroupModalTitle = "ویرایش  گروه متا دیتا"
                        this.showAddOrEditMetaGroupModal()
                    }
                })
            }
        }, created() {
            this.getMetadataGroups()
        }
    }
</script>